<template>
  <div>
    <a-modal
      title="操作"
      style="top: 20px"
      :width="820"
      v-model="visible"
      :confirmLoading="confirmLoading"
      :maskClosable="false"
      @cancel="handleClose"
      @ok="handleSubmit"
      :footer="false"
    >
      <div class="table-page-search-wrapper">
        <div class="table-page-search-wrapper">
          <a-form :form="form" layout="inline">
            <a-row :gutter="7">
              <a-col :span="7">
                <a-form-item label="姓名">
                  <a-input v-model="queryParam.name" disabled="disabled" />
                </a-form-item>
              </a-col>
              <a-col :span="7">
                <a-form-item label="身份证号">
                  <a-input v-model="queryParam.idCard" disabled="disabled" />
                </a-form-item>
              </a-col>
              <a-col :span="7">
                <a-form-item label="申请时间">
                  <a-input v-model="queryParam.applyTime" disabled="disabled" />
                </a-form-item>
              </a-col>
            </a-row>

            <div style="margin-top: 20px">
              <!--上传身份证图片-->
              <a-row :gutter="16">
                <a-col :span="7">
                  <a-form-item label="正面">
                    <div class="clearfix">
                      <a-upload
                        :action="uploadUrlb"
                        listType="picture-card"
                        :fileList="fileList1"
                        :headers="headers"
                        :beforeUpload="beforeUpload1"
                        @preview="handPreview1"
                        @change="handChange1"
                      >
                        <div v-if="fileList1.length < 1">
                          <a-icon type="plus" />
                          <div class="ant-upload-text">正面</div>
                        </div>
                      </a-upload>
                      <a-modal :visible="previewVisible1" :footer="null" @cancel="handCancel1">
                        <img alt="example" style="width: 100%" :src="coverUrl1" disabled="disabled" />
                      </a-modal>
                    </div>
                  </a-form-item>
                </a-col>
                <a-col :span="7">
                  <a-form-item label="反面">
                    <div class="clearfix">
                      <a-upload
                        :action="uploadUrlb"
                        listType="picture-card"
                        :fileList="fileList2"
                        :headers="headers"
                        :beforeUpload="beforeUpload1"
                        @preview="handPreview2"
                        @change="handChange2"
                      >
                        <div v-if="fileList2.length < 1">
                          <a-icon type="plus" />
                          <div class="ant-upload-text">反面</div>
                        </div>
                      </a-upload>
                      <a-modal :visible="previewVisible2" :footer="null" @cancel="handCancel2">
                        <img alt="example" style="width: 100%" :src="coverUrl2" disabled="disabled" />
                      </a-modal>
                    </div>
                  </a-form-item>
                </a-col>
                <a-col :span="7">
                  <a-form-item style="margin-left: 12px" label="手持证件照">
                    <div class="clearfix">
                      <a-upload
                        :action="uploadUrlb"
                        listType="picture-card"
                        :fileList="fileList3"
                        :headers="headers"
                        :beforeUpload="beforeUpload1"
                        @preview="handPreview3"
                        @change="handChange3"
                      >
                        <div v-if="fileList3.length < 1">
                          <a-icon type="plus" />
                          <div class="ant-upload-text">手持证件照</div>
                        </div>
                      </a-upload>
                      <a-modal :visible="previewVisible3" :footer="null" @cancel="handCancel3">
                        <img alt="example" style="width: 100%" :src="coverUrl3" disabled="disabled" />
                      </a-modal>
                    </div>
                  </a-form-item>
                </a-col>
              </a-row>
            </div>

            <div style="margin-top: 80px">
              <a-row :gutter="16" style="margin-bottom: 60px">
                <a-col :span="22">
                  <a-form-item label="反馈信息" style="width: 100%; margin-bottom: 20px">
                    <a-textarea disabled="disabled" v-model="queryParam.authRemark" />
                  </a-form-item>
                </a-col>
              </a-row>
            </div>

            <div>
              <div class="flex_l">师傅负责人：{{ queryParam.leader }}</div>
            </div>
          </a-form>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import pick from 'lodash.pick'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import moment from 'moment'
import { getIdentityById, review } from '@/api/master/idCardList'

export default {
  name: 'idCardEdit',
  components: {},
  data() {
    return {
      visible: false,
      dateModel: false,
      record: '',
      confirmLoading: false,
      form: this.$form.createForm(this),
      queryParam: {},
      isType2: '', // 照片上传判断
      previewVisible1: false,
      previewVisible2: false,
      previewVisible3: false,
      // 上传
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN),
      },
      previewVisible: false,
      uploadUrlb: process.env.VUE_APP_API_BASE_URL + '/dfs/upload?type=master',
      picture1: '',

      fileList1: [],
      fileList2: [],
      fileList3: [],
      fileList4: [],
      coverUrl1: '',
      coverUrl2: '',
      coverUrl3: '',
      identity: [
        {
          identityType: '',
          identityUrl: '',
        },
        {
          identityType: '',
          identityUrl: '',
        },
        {
          identityType: '',
          identityUrl: '',
        },
      ], //上传图片
    }
  },
  beforeCreate() {},
  created() {},
  mounted() {},
  methods: {
    moment,
    onOk(value) {
      console.log('onOk: ', value)
    },
    handleShow(record) {
      this.record = record
      this.dateModel = true
    },

    edit(id) {
      this.queryParam = {}
      let that = this
      getIdentityById(id).then((res) => {
        if (res.code === 0) {
          this.queryParam = res.data
          this.fileList1.splice(0, this.fileList1.length)
          this.fileList2.splice(0, this.fileList2.length)
          this.fileList3.splice(0, this.fileList3.length)

          this.identity = [
            {
              identityType: '',
              identityUrl: '',
            },
            {
              identityType: '',
              identityUrl: '',
            },
            {
              identityType: '',
              identityUrl: '',
            },
          ]
          let arr = this.queryParam.identityList
          for (let id of arr) {
            if (id.identityType == '0') {
              this.getImgToBase64(
                process.env.VUE_APP_API_BASE_URL +
                  '/dfs/download?fileName=' +
                  id.identityUrl +
                  '&token=' +
                  Vue.ls.get(ACCESS_TOKEN),
                function (data) {
                  that.fileList1.push({
                    uid: id.identityType,
                    name: '',
                    status: 'done',
                    thumbUrl: data,
                    url: id.identityUrl,
                  })
                }
              )
              this.identity[0].identityType = 0
              this.identity[0].identityUrl = id.identityUrl
            }

            if (id.identityType == '1') {
              this.getImgToBase64(
                process.env.VUE_APP_API_BASE_URL +
                  '/dfs/download?fileName=' +
                  id.identityUrl +
                  '&token=' +
                  Vue.ls.get(ACCESS_TOKEN),
                function (data) {
                  that.fileList2.push({
                    uid: id.identityType,
                    name: '',
                    status: 'done',
                    thumbUrl: data,
                    url: id.identityUrl,
                  })
                }
              )
              this.identity[1].identityType = 1
              this.identity[1].identityUrl = id.identityUrl
            }
            if (id.identityType == '3') {
              this.getImgToBase64(
                process.env.VUE_APP_API_BASE_URL +
                  '/dfs/download?fileName=' +
                  id.identityUrl +
                  '&token=' +
                  Vue.ls.get(ACCESS_TOKEN),
                function (data) {
                  that.fileList3.push({
                    uid: id.identityType,
                    name: '',
                    status: 'done',
                    thumbUrl: data,
                    url: id.identityUrl,
                  })
                }
              )
              this.identity[2].identityType = 2
              this.identity[2].identityUrl = id.identityUrl
            }
          }
          this.visible = true
        } else {
          this.$message.error(res.msg)
        }
      })
    },

    // 不通过
    publish(type) {
      this.queryParam.nameAuth = type
      review(this.queryParam).then((res) => {
        if (res.code === 0) {
          this.$message.success('提交成功!')
          this.visible = false
          this.$emit('ok')
        } else {
          this.$message.error(res.msg)
        }
      })
    },

    handleClose() {
      this.getClose()
    },
    getClose() {
      this.visible = false
      this.fileList1 = []
      this.picture1 = ''
    },

    handCancel1() {
      this.previewVisible1 = false
    },
    // 上传1
    handChange1({ fileList }) {
      this.fileList1 = fileList
      console.log(this.fileList1)
      this.coverUrl1 = fileList[0].response.url
      if (fileList[0].status == 'done') {
        this.picture1 = this.coverUrl1
      }
      if (fileList.length == 0) {
        this.isTrueText = false
      }
    },

    handPreview1(file) {
      if (file.response) {
        this.coverUrl1 =
          process.env.VUE_APP_API_BASE_URL +
          '/dfs/download?fileName=' +
          file.response.url +
          '&token=' +
          Vue.ls.get(ACCESS_TOKEN)
      } else {
        this.coverUrl1 =
          process.env.VUE_APP_API_BASE_URL + '/dfs/download?fileName=' + file.url + '&token=' + Vue.ls.get(ACCESS_TOKEN)
      }
      this.previewVisible1 = true
    },
    beforeUpload1(file) {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
      if (!isJpgOrPng) {
        this.$message.error('上传文件格式不支持!')
        this.isType2 = 1
        return false
      } else {
        this.isType2 = 0
      }
    },
    //将图片转换为Base64
    getImgToBase64(url, callback) {
      var canvas = document.createElement('canvas'),
        ctx = canvas.getContext('2d'),
        img = new Image()
      img.crossOrigin = 'Anonymous'
      img.onload = function () {
        canvas.height = img.height
        canvas.width = img.width
        ctx.drawImage(img, 0, 0)
        var dataURL = canvas.toDataURL('image/png')
        callback(dataURL)
        canvas = null
      }
      img.src = url
    },
    handPreview2(file) {
      if (file.response) {
        this.coverUrl2 =
          process.env.VUE_APP_API_BASE_URL +
          '/dfs/download?fileName=' +
          file.response.url +
          '&token=' +
          Vue.ls.get(ACCESS_TOKEN)
      } else {
        this.coverUrl2 =
          process.env.VUE_APP_API_BASE_URL + '/dfs/download?fileName=' + file.url + '&token=' + Vue.ls.get(ACCESS_TOKEN)
      }
      this.previewVisible2 = true
    },
    // 上传2
    handChange2({ fileList }) {
      if (this.isType2 == 0) {
        this.fileList2 = fileList
        if (fileList.length == 0) {
          this.identity[1].identityType = ''
          this.identity[1].identityUrl = ''
          this.isTrueTime = false
          // console.log(this.identity[1])
        } else {
          this.coverUrl2 = fileList[0].response.url
          this.identity[1].identityType = 1
          this.identity[1].identityUrl = this.coverUrl2
        }
        let url =
          process.env.VUE_APP_API_BASE_URL +
          '/dfs/download?fileName=' +
          fileList[0].response.url +
          '&token=' +
          Vue.ls.get(ACCESS_TOKEN)
        // let url = 'http://121.36.221.107/api/dfs/download?fileName=master/2020/07/31/e61e6ecb2a12d4fc0ed4ada23548e1c3.jpg&token=3799467ae9714eb293146dd2fa4fcd11'
        if (fileList.length > 0 && fileList[0].status == 'done') {
        }
      }
    },
    handCancel2() {
      this.previewVisible2 = false
    },
    handPreview3(file) {
      if (file.response) {
        this.coverUrl3 =
          process.env.VUE_APP_API_BASE_URL +
          '/dfs/download?fileName=' +
          file.response.url +
          '&token=' +
          Vue.ls.get(ACCESS_TOKEN)
      } else {
        this.coverUrl3 =
          process.env.VUE_APP_API_BASE_URL + '/dfs/download?fileName=' + file.url + '&token=' + Vue.ls.get(ACCESS_TOKEN)
      }
      this.previewVisible3 = true
    },
    handCancel3() {
      this.previewVisible3 = false
    },

    // 上传3
    handChange3({ fileList }) {
      if (this.isType2 == 0) {
        this.fileList3 = fileList
        if (fileList.length == 0) {
          this.identity[2].identityType = ''
          this.identity[2].identityUrl = ''
        } else {
          this.coverUrl3 = fileList[0].response.url
          this.identity[2].identityType = 2
          this.identity[2].identityUrl = this.coverUrl3
        }
      }
    },
  },
}
</script>

<style scoped>
.readyOnly {
  pointer-events: none;
}
</style>